<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Terman</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="termanFactorForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar factor</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Titulo</label>
                                    <input [(ngModel)]="rank.title" [ngModelOptions]="{standalone:true}"  type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Descripción</label>
                                    <input [(ngModel)]="rank.description" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Descripción">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Intervalo inferior</label>
                                    <input [(ngModel)]="rank.low" [ngModelOptions]="{standalone:true}" type="number"  class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Intervalo superior</label>
                                    <input [(ngModel)]="rank.high" [ngModelOptions]="{standalone:true}" type="number"  class="form-control" >
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Serie</label>
                                    <select formControlName="serie" class="form-control custom-select">
                                        <option selected value="informacion">1 - Información</option>
                                        <option value="juicio">2 - Juicio</option>
                                        <option value="vocabulario">3 - Vocabulario</option>
                                        <option value="sintesis">4 - Síntesis</option>
                                        <option value="Concentración">5 - Concentración</option>
                                        <option value="analisis">6 - Análisis</option>
                                        <option value="abstraccion">7 - Abstracción</option>
                                        <option value="planeacion">8 - Planeación</option>
                                        <option value="organizacion">9 - Organización</option>
                                        <option value="atencion">10 - Atención</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-actions ">
                                    <button type="button" class="btn btn-primary" (click)="addRank()"> <i class="fa fa-plus"></i> Agregar rango</button>
                                </div>    
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2">
                                <p><span>Rangos: </span></p>
                            </div>
                            <div *ngFor="let i of rankArray" class="col-2">
                                <p>{{i.low}} - {{i.high}}</p>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row m-t-20">
                        <div class="form-actions m-r-10 m-l-10">
                            <button type="submit" class="btn btn-success waves-effect"> Crear</button>
                        </div>
    
                        <div class="form-actions">
                            <button type="button" (click)="reset()" class="btn btn-warning waves-effect">  Reiniciar</button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>